import React, { useEffect, useRef, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Box } from "@mui/material";
import {
  getExtra,
  getExtraError,
  getExtraStatus,
  getExtraSuccess,
  deleteExtra,
  selectAllExtra,
  updateStatus,
} from "../../../features/extraSlice";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import ProductCard from "../../../components/card";
import NoData from "../../../components/noData";
import AppBarSearch from "../../../global/appBarSearch";
import AlertDialog from "../../../components/alertDialog";
import { toast } from "react-toastify";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { useTranslation } from "react-i18next";
import { CardField, CardStatus } from "../../../components/cardMeta";

const Extra = () => {
  const { t } = useTranslation();
  const { restaurantId ,currency } = useRestaurant();
  const [filteredExtras, setFilteredExtras] = useState([]);
  const dispatch = useDispatch();
  const status = useSelector(getExtraStatus);
  const error = useSelector(getExtraError);
  const extras = useSelector(selectAllExtra);
  const success = useSelector(getExtraSuccess);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [cardId, setCardId] = useState(null);
  const handleClickOpen = (cardId) => {
    setOpen(true);
    setCardId(cardId);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("add");
  };
  const handleModify = (data) => {
    navigate("modify", { state: { extra: data } });
  };
  const hasFetchedInMountRef = useRef(false);
  const lastFetchedRestaurantRef = useRef(restaurantId);
  useEffect(() => {
    const restaurantChanged =
      hasFetchedInMountRef.current &&
      lastFetchedRestaurantRef.current !== restaurantId;
    const alreadyLoaded = extras.length > 0 && status === "fetchData";
    if (restaurantChanged || !alreadyLoaded) {
      dispatch(getExtra(restaurantId));
    }
    hasFetchedInMountRef.current = true;
    lastFetchedRestaurantRef.current = restaurantId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "fetchData") {
      setFilteredExtras(
        extras?.filter((dish) =>
          dish.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [extras, search, status]);

  useEffect(() => {
    if (status === "deleteSuccess") {
      toast.success(success);
      setFilteredExtras((prev) => prev.filter((item) => item._id !== cardId));
      dispatch(updateStatus());
    } else if (status === "deleteError") {
      toast.error(error);
    }
  }, [status, error, success, dispatch, cardId]);
  return (
    <div className="main-application">
      <CssBaseline />
      <AppBarSearch
        handleSubmit={handleSubmit}
        handleSearch={(e) => setSearch(e.target.value)}
        title={t("pages.myExtras")}
        buttonTitle={t("actions.addExtra")}
      />
      <main>
        <Box maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={2}>
            {status === "loadingFetchData" ? (
              <Loading />
            ) : status === "fetchError" ? (
              <Error>{error}</Error>
            ) : (
              <>
                {filteredExtras && filteredExtras.length > 0 ? (
                  filteredExtras.map((card) => (
                    <ProductCard
                      key={card._id}
                      data={card}
                      handleModify={() => handleModify(card)}
                      content={
                        <>
                          <CardField label={t("fields.price")}>
                            {card.price ?? 0} {currency}
                          </CardField>
                          <CardStatus
                            outOfStock={card.outOfStock}
                            visible={card.visible}
                          />
                        </>
                      }
                      handleClickOpen={() => handleClickOpen(card._id)}
                    />
                  ))
                ) : (
                  <NoData />
                )}
                <AlertDialog
                  handleClose={() => setOpen(false)}
                  open={open}
                  name={"extra"}
                  cardId={cardId}
                  deleteData={() =>
                    dispatch(deleteExtra({ extraId: cardId, restaurantId }))
                  }
                />
              </>
            )}
          </Grid>
        </Box>
      </main>
    </div>
  );
};

export default Extra;
